import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatType } from './date-format-type';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe extends DatePipe implements PipeTransform {
    transform(value: any, format: DateFormatType = DateFormatType.DATE): any {
        let f = 'dd.MM.yyyy';
        if (format === DateFormatType.DATE_TIME) {
            f = 'dd.MM.yyyy HH:mm';
        } else if (format === DateFormatType.TIME) {
            f = 'HH:mm';
        }
        return super.transform(value, f);
    }
}
